import React from 'react';
import { Modal } from 'antd';
import useApi from '../../hooks/useApi';
import useUserType from '../../hooks/useUserType';

const ModalDelete = ({ visible, id, onCancel, onSuccess }) => {

  const userType = useUserType();

  const { callApi: deleteGrupo } = useApi(`https://vision.alfama.com/api/delete/grupos_permissao/${id}`, {
    method: 'DELETE',
    includeToken: true,
    successMessage: 'Grupo excluído com sucesso!',
    errorMessage: 'Erro ao excluir grupo'
  });

  if (userType !== 'administrador') {
    return (
      <Modal
        title={
          <div className="flex items-center gap-2 text-red-500">
            Aviso
          </div>
        }
        open={visible}
        onCancel={onCancel}
        footer={null}
      >
        <p>Somente administradores podem excluir grupos de permissão.</p>
      </Modal>
    );
  }

  const handleConfirm = async () => {
    try {
      await deleteGrupo();
      onCancel();
      onSuccess();
    } catch (error) {
      console.error('Erro ao excluir grupo:', error);
    }
  };

  return (
    <Modal
      title={
        <div className="flex items-center gap-2 text-red-500">
          Confirmação de Exclusão de Grupo
        </div>
      }
      open={visible}
      onCancel={onCancel}
      onOk={handleConfirm}
      okText="Confirmar"
      cancelText="Cancelar"
      okButtonProps={{ 
        danger: true,
        className: 'bg-red-500'
      }}
    >
      <p>Tem certeza que deseja excluir o ID: <strong>{id}</strong>?</p>
      <p>Esta ação não poderá ser desfeita.</p>
    </Modal>
  );
};

export default ModalDelete;